<template>
    <div>
        <div class="content">
            <div class="topcontent">
                <p class="allmessage">全部消息</p>
                <p class="read" @click="readAll">全部标记已读</p>
            </div>
            <!-- <el-divider></el-divider> -->
            <div
                v-for="item in messagelist"
                :key="item.index"
                class="messagecontent"
                @click="messageToChat(item)"
            >
                <img :src="item.bavatar" class="avatar" />
                <div class="rightcontent">
                    <div class="top">
                        <p class="name">{{item.bname}}</p>
                        <p class="time">{{item.create}}</p>
                        <div v-if="item.watched == 0" class="dot">
                            <el-badge is-dot class="item"></el-badge>
                        </div>
                    </div>
                    <p
                        v-for="message in item.lastone"
                        :key="message.index"
                        class="message"
                    >{{message.content}}</p>
                </div>
            </div>
            <el-pagination
                background
                layout="jumper, prev, pager, next, slot, total"
                :total="total"
                :current-page="page"
                @current-change="currentChange"
                @prev-click="prevClick"
                @next-click="nextClick"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                messagelist: [],
                total: 0,
                page: 1
            };
        },
        mounted() {
            this.getmessagelist();
        },
        methods: {
            getmessagelist() {
                this.httpGet(this.$root.getnewslist, {
                    page: this.page
                })
                    .then(result => {
                        if (result.count) {
                            this.messagelist.push(...result.list);
                            this.total = Number(result.count);
                        } else {
                            this.messagelist = [];
                            this.total = 0;
                        }
                        console.log(result, 777);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            messageToChat(item) {
                if (this.$route.query.buid != item.buid) {
                    this.$router.replace({
                        name: 'personal-center',
                        query: {
                            buid: item.buid
                        }
                    });
                } else {
                    this.$emit('messageChat', item.uid);
                }
            },
            readAll() {
                this.httpPost(this.$root.setReadAll, {})
                    .then(result => {
                        this.messagelist = [];
                        this.getmessagelist();
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            currentChange(page) {
                console.log('currentChange', page);
                this.page = page;
                this.messagelist = [];
                this.getmessagelist();
            },
            prevClick(page) {
                console.log('currentChange1', page);
                this.page = page;
                this.messagelist = [];
                this.getmessagelist();
            },
            nextClick(page) {
                console.log('currentChange2', page);
                this.page = page;
                this.messagelist = [];
                this.getmessagelist();
            }
        }
    };
</script>
<style lang="stylus"  rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    >>>.el-pagination {
        // width: 840px;
        flex-center();
        padding: 20px;
        background: white;
    }

    .content {
        background-color: white;
        border-radius: 8px;
        width: 832px;
        padding: 0 20px;
        box-sizing: border-box;

        .topcontent {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 20px 0;
            border-bottom: 1px solid #f5f5f5;
            flex-x();

            .allmessage {
                font-size: 16px;
            }

            .read {
                font-size: 14px;
                opacity: 0.45;
            }

            .read:hover {
                cursor: pointer;
            }
        }

        .messagecontent {
            padding: 24px 0;
            border-bottom: 1px solid #f5f5f5;
            display: flex;
            flex-direction: row;

            .avatar {
                border-radius: 50px;
                width: 48px;
                height: 48px;
            }

            .rightcontent {
                display: flex;
                flex-direction: column;

                .top {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-left: 24px;
                    position: relative;
                    width 100%
                    width 702px

                    .name {
                        font-size: 16px;
                        font-weight: bold;
                    }

                    .time {
                        font-size: 12px;
                        opacity: 0.45;
                        margin-left: 24px;
                    }

                    .dot {
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }

                .message {
                    margin-left: 24px;
                    font-size: 14px;
                    opacity: 0.65;
                    margin-top: 10px;
                    line-height: 1.4;
                }
            }
        }
    }
</style>
